export * from './footer.component';



// WEBPACK FOOTER //
// ./src/components/app/footer/index.ts